module.exports = __webpack_public_path__ + "img/banner7.7984345d.jpg";